import request from '@/utils/request'
import { v2Host } from '@/config/host'
// import { cookRequestParams } from '@/modules/common/request'

/**
 * getNoninteractiveTagList
 * http://playable.dev.com:8067/?doc=system/noninteractive_tag.go
 */
export function getNoninteractiveTagList() {
  return request({
    url: `${v2Host}/system/noninteractive-tag/list`,
    method: 'get'
  })
}

/**
 * 创建标签
 * http://playable.dev.com:8067/?doc=system/noninteractive_tag.go
 * @param {{pid: number, name: string, is_required: number}} data
 */
export function createNoninteractiveTag(data) {
  return request({
    url: `${v2Host}/system/noninteractive-tag/create`,
    method: 'post',
    data: data
  })
}

/**
 * 更新标签
 * http://playable.dev.com:8067/?doc=system/noninteractive_tag.go
 * @param {{id: number}}
 * @param {{name: string, is_required: number}} data
 */
export function updateNoninteractiveTag(params, data) {
  return request({
    url: `${v2Host}/system/noninteractive-tag/update`,
    method: 'post',
    params: params,
    data: data
  })
}

/**
 * 删除标签
 * http://playable.dev.com:8067/?doc=system/noninteractive_tag.go
 * @param {{id: number}} params
 */
export function deleteNoninteractiveTag(params) {
  return request({
    url: `${v2Host}/system/noninteractive-tag/delete`,
    method: 'post',
    params: params
  })
}
